module.exports = __webpack_public_path__ + "images/howtouse/flow03_7d24018d23e49c2459c3b84597b59774.png";